<!--<div class="layout-topbar">-->
<!--    <a class="layout-topbar-logo" routerLink="">-->
<!--        <img src="assets/layout/images/logo-sample.png" alt="logo">-->
<!--    </a>-->

<!--    <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">-->
<!--        <i class="pi pi-bars"></i>-->
<!--    </button>-->

<!--    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button" (click)="layoutService.showProfileSidebar()">-->
<!--        <i class="pi pi-ellipsis-v"></i>-->
<!--    </button>-->

<!--    <div #topbarmenu class="layout-topbar-menu" [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">-->
<!--&lt;!&ndash;        <button class="p-link layout-topbar-button" (click)="menu.toggle($event)">&ndash;&gt;-->
<!--&lt;!&ndash;            <i class="pi pi-user"></i>&ndash;&gt;-->
<!--&lt;!&ndash;            <span>Profile</span>&ndash;&gt;-->
<!--&lt;!&ndash;        </button>&ndash;&gt;-->

<!--&lt;!&ndash;        <p-menu #menu [model]="items" [popup]="true" />&ndash;&gt;-->

<!--      -->


<!--    </div>-->
<!--</div>-->
<div class="layout-topbar">
  <div class="topbar-title gap-3">
    <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
      <i class="pi pi-bars"></i>
    </button>
    <a class="layout-topbar-logo" routerLink="">
      <img src="assets/layout/images/logo-sample.png" alt="logo" />
    </a>
  </div>
  <div class="topbar-center">
    <p-dropdown
    *ngIf="showProgramDropdown"
    placeholder="Program"
    class="block program-dropdown"
    [options]="programs"
    [styleClass]="'w-full'"
    optionLabel="name"
    optionValue="id"
    [(ngModel)]="selectedProgramId"
    (onChange)="onProgramChange($event)"
    [filter]="true"
    filterBy="name">
  </p-dropdown>
  </div>
  <div class="topbar-right">
    <ul class="topbar-menu">


      <li class="profile-item md:relative">
        <a tabindex="0" pstyleclass="@next" style="width: 14rem;" enterclass="hidden" enteractiveclass="scalein" leavetoclass="hidden" leaveactiveclass="fadeout" class="p-element" (click)="toggleProfile($event)"
        ><img src="assets/layout/images/profile.png" alt="diamond-layout" class="profile-image" /> <span class="profile-name">{{ userName }}</span></a
        >
        <ul [class.hidden]="toggleProfileClassState" #profileul class="list-none p-3 m-0 border-round shadow-2 absolute surface-overlay origin-top w-full sm:w-14rem mt-2 right-0 z-5 top-auto hidden">
          <li>
            @if(showRefreshCookie)
            {
              <a
                (click)="RefreshCookie()"
                class="p-ripple p-element flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                <i class="pi pi-refresh mr-3"></i>
                <span class="flex flex-column">
                  <span class="font-semibold">Refresh Cookie</span>
                </span>
                <span class="p-ink"></span>
              </a>
            }

            <a pripple="" href="/change-password" class="p-ripple p-element flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
            ><i class="pi pi-user-edit mr-3"></i><span class="flex flex-column"><span class="font-semibold">Change Password</span></span
            ><span class="p-ink"></span></a
            >

            <a (click)="logout()"  pripple="" class="p-ripple p-element flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
            ><i class="pi pi-power-off mr-3"></i><span class="flex flex-column"><span class="font-semibold">Logout</span></span
            ><span class="p-ink"></span
            ></a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>
<p-toast />
<p-confirmDialog></p-confirmDialog>
<!-- <p-dialog
  header="Select a Program"
  [(visible)]="showSelectProgramModal"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="false"
  [style]="{ width: '30vw' }"
>
  <p>Please select a program to proceed.</p>

</p-dialog> -->
<p-dialog
  [(visible)]="showSelectProgramModal"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="false"
  [style]="{ width: '20vw' }"
>
  <div class="dialog-content-center">
    <div class="main-text">Please select a program to proceed.</div>
    <div class="sub-text">Once you select a program, you will be redirected to the program's dashboard.</div>
    <div class="dialog-actions">
      <button pButton type="button" class="p-button-text p-button-outlined wide-btn" (click)="showSelectProgramModal = false">Cancel</button>
    </div>
  </div>
</p-dialog>
